import cn from 'classnames';
import * as React from 'react';
import {FileViewerHeaderLabel} from './FileViewerHeaderLabel';
import {SCROLL_DEBOUNCE_TIME, THUMBNAIL_SIZE_GRID} from '../const';
import {ItemType, StudioFileItemParamProps, StudioFileViewerProps} from '.';
import StudioVirtualizedGrid, {
  StudioVirtualizedGridProps,
} from '../../StudioVirtualizedGrid/StudioVirtualizedGrid';
import {GridOnItemsRenderedProps} from 'react-window';
import {debounce} from 'lodash';
import './GridViewer.scss';

const gridThumbnailSizeParam = `previewDimensions=${THUMBNAIL_SIZE_GRID}x${THUMBNAIL_SIZE_GRID}`;

export type GridViewerProps = {
  children?: React.ReactNode;
  className?: string;
  count?: number;
  label?: string;
  items?: ItemType[];
  imageRenderer?: (config: StudioFileItemParamProps) => React.ReactNode;
  onScrollStop?: (args: GridOnItemsRenderedProps) => void;
} & Pick<StudioFileViewerProps, 'imageRenderer' | 'selections' | 'onSelect'>;

export type GridViewerVirtualizedProps = GridViewerProps & {
  width?: number;
  height?: number;
  rowHeight?: number;
  columnWidth?: number;
} & Pick<StudioVirtualizedGridProps, 'loadMore' | 'totalData'>;

export type GridViewProps = GridViewerProps | GridViewerVirtualizedProps;

export const GridViewer = ({
  children,
  className,
  count,
  label,
  selections,
}: GridViewerProps) => (
  <div className={cn('grid-viewer', className)}>
    {label && count && (
      <FileViewerHeaderLabel
        selected={selections?.length || 0}
        label={label}
        count={count}
      />
    )}
    <div className="grid-viewer__content">{children}</div>
  </div>
);

// TODO: Improve this component to adapt to dynamic items size
export const GridViewerVirtualized = ({
  imageRenderer = () => <></>,
  selections = [],
  items = [],
  loadMore,
  totalData,
  rowHeight = 100,
  columnWidth = 100,
  onScrollStop = () => {},
}: GridViewerVirtualizedProps) => {
  const debouncedOnScrollStop = debounce(
    (args: GridOnItemsRenderedProps) => onScrollStop(args),
    SCROLL_DEBOUNCE_TIME
  );

  const onItemsRendered = (args: GridOnItemsRenderedProps) => {
    debouncedOnScrollStop(args);
  };
  return (
    <StudioVirtualizedGrid
      data={items}
      columnWidth={columnWidth}
      rowHeight={rowHeight}
      totalData={totalData}
      loadMore={loadMore}
      onItemsRendered={onItemsRendered}
    >
      {({style, data, ...rest}) => {
        const item = data as ItemType;
        if (item) {
          const selected = selections.includes(item.id);
          return (
            <div style={style}>
              {imageRenderer?.({
                id: String(item.id),
                type: item.type || '',
                selected,
                url: item.file || `${item.url}&${gridThumbnailSizeParam}`,
                item,
              })}
            </div>
          );
        }
        return <></>;
      }}
    </StudioVirtualizedGrid>
  );
};
